import { render, staticRenderFns } from "./jieshunHome.vue?vue&type=template&id=38c91614&scoped=true"
import script from "./jieshunHome.vue?vue&type=script&lang=js"
export * from "./jieshunHome.vue?vue&type=script&lang=js"
import style0 from "./jieshunHome.vue?vue&type=style&index=0&id=38c91614&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38c91614",
  null
  
)

export default component.exports